import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Themes from '../styling/themes';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.IsServer ??= true;
global.disableStylesGeneration = false;
global.Themes = Themes;
